import { put, takeLatest, fork, call } from "redux-saga/effects";
import { ActionType, IUpdateVenuesResponse } from "models/vaccine/updateVenues";
import { httpStatus } from "configs/httpStatus";
import { updateVenues } from "services/vaccine";
import { handleSuccesAction, handleErrorAction } from "./updateVenuesActions";

function* updateVenuesSaga({
  payload,
}: {
  payload: { id: number; value: any };
}) {
  try {
    const response: IUpdateVenuesResponse = yield call(updateVenues, payload);

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onUpdateVenuesWatcher() {
  yield takeLatest(ActionType.VACCINE_UPDATE_VENUES as any, updateVenuesSaga);
}

export default [fork(onUpdateVenuesWatcher)];
